<template>
  <div class="formDialog">
    <el-dialog title="选择发起人"
               visible
               width="900px"
               :close-on-click-modal="false"
               append-to-body
               :before-close="close">
      <div class="public-searchForm">
        <el-form ref="searchForm"
                 inline
                 :model="searchForm"
                 size="small"
                 @submit.native.prevent>
          <!--
        <el-form-item
          prop="userName"
          label="姓名"
        >
          <el-input
            v-model.trim="searchForm.userName"
            clearable
            placeholder="请输入姓名"
            @keyup.enter.native.stop="search"
          />
        </el-form-item>
         -->
          <el-form-item prop="jobId">
            <el-input v-model.trim="searchForm.jobId"
                      clearable
                      placeholder="请输入工号或姓名"
                      @keyup.enter.native.stop="search"
                      @clear="search" />
          </el-form-item>
          <el-form-item>
            <el-button type="default"
                       @click="reset">
              重置
            </el-button>
            <el-button type="primary"
                       @click="search">
              查询
            </el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="public-table">
        <el-table ref="tableData"
                  :data="tableData"
                  height="300"
                  border
                  size="small"
                  @row-click="rowClick"
                  @selection-change="selectionChange">
          <el-table-column v-if="multiple"
                           type="selection"
                           width="55"
                           align="center" />
          <el-table-column v-for="item in tableCol"
                           :key="item.key"
                           :prop="item.key"
                           :label="item.label" />
          <el-table-column v-if="!multiple && !hideHandle"
                           label="操作"
                           width="60">
            <div slot-scope="scope"
                 class="public-form-table-item-operate">
              <a @click.stop="selectItem(scope.row)">选中</a>
            </div>
          </el-table-column>
        </el-table>
      </div>
      <div class="public-pagination">
        <WPagination v-model="page"
                     @change="query" />
      </div>
    </el-dialog>
  </div>
</template>
<script>
import api from '@workflow/api/index.js'
export default {
  props: {
    multiple: {
      type: Boolean,
      default: false
    },
    hideHandle: {
      type: Boolean,
      default: false
    },
    seleted: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      searchForm: {
        jobId: ''
      },
      selectParam: {},
      page: {},
      tableCol: [
        { label: '姓名', key: 'name' }, // userName
        { label: '工号', key: 'jobId' }, // employeeNo
        { label: '手机号', key: 'cellphone' } // mobile
        // { label: '用户账号', key: 'account' }
      ],
      tableData: []
    }
  },
  mounted() {
    this.search()
  },
  methods: {
    selectItem(row) {
      this.$emit('selectUser', row)
      this.close()
    },
    close() {
      this.$emit('close')
    },
    reset() {
      this.$refs.searchForm.resetFields()
      this.search()
    },
    search() {
      this.page.current = 1
      this.page.size = 10
      this.selectParam = { ...this.searchForm }
      this.query()
    },
    query() {
      const { current, size } = this.page
      api
        .getUserList({
          pageParam: { current, size },
          selectParam: this.selectParam
        })
        .then((data) => {
          this.tableData = data.records
          this.page.total = data.total
          this.onSetCheck = true
          this.$nextTick(() => {
            this.setCheck(this.seleted)
            this.onSetCheck = false
          })
        })
    },
    rowClick(row) {
      if (this.multiple) return
      this.$emit('handleSelect', row)
    },
    selectionChange(data) {
      this.$emit('selectionChange', data)
    },
    setCheck(list) {
      this.tableData.forEach((item, index) => {
        this.$refs.tableData.toggleRowSelection(item, list.includes(item.jobId))
      })
    }
  }
}
</script>
<style lang="scss">
</style>
